export class DhcError {
    pos = 0;
    errorMessage: string;
}
